import { Component, HostListener, inject } from '@angular/core';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faFileText, faSitemap } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EngagementService } from '../../../core/services/engagement/engagement.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
})
export class FooterComponent {
  private _engagementService = inject(EngagementService);
  faQuestionCircle = faQuestionCircle;
  faFileText = faFileText;
  faSiteMap = faSitemap;
  year: number = new Date().getFullYear();
  isShow: boolean = false;
  showHelpMenu: boolean = false;
  faqHover!: boolean;
  iShareHover!: boolean;
  footerHeight: number = 50;

  constructor() {
    this._engagementService.setMenuInactive();
  }

  ngOnInit() {
    const footer = document.getElementById('footer-container');
    if (footer) {
      this.footerHeight = footer.offsetHeight;
    }

  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (window.innerWidth < 1500 && window.innerWidth > 768) {
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
      document.documentElement.style.setProperty('--scroll-left', `${scrollLeft}px`);
    } else {
      document.documentElement.style.setProperty('--scroll-left', '0px');
    }
  }

  changeShowHelp() {
    this.showHelpMenu = !this.showHelpMenu;
  }
}
